import {
  CITATION_LIST_TITLE_SINGLE,
  CITATION_LIST_NAME_LOWER_SINGLE,
  CITATION_LIST_NAME_LOWER_PLURAL,
} from './citations'

export const ErrorMsgs = {
  // Display errors
  DELETE_FOLDER_ERROR: 'Folder could not be deleted',
  EDIT_FOLDER_ERROR: 'Folder could not be updated',
  ADD_FOLDER_ERROR: 'Folder could not be created',
  FETCH_FOLDERS_ERROR: 'Folders could not be loaded',
  CREATE_PROJECT_ERROR: `${CITATION_LIST_TITLE_SINGLE} could not be created`,
  DELETE_PROJECT_ERROR: `${CITATION_LIST_TITLE_SINGLE} could not be deleted`,
  GET_PROJECT_ERROR: `This ${CITATION_LIST_NAME_LOWER_SINGLE} could not be loaded`,
  UPDATE_PROJECT_ERROR: `There was a problem updating your ${CITATION_LIST_NAME_LOWER_SINGLE}`,
  ADD_CITATION_ERROR: 'There was a problem adding your citation',
  SAVE_CITATION_ERROR: 'There was a problem trying to save the citation',
  GET_CITATION_ERROR: 'The citation could not be loaded',
  GET_CITATIONS_ERROR: 'Citations could not be loaded',
  CITATIONS_COUNT_ERROR: `There was a problem retrieving your ${CITATION_LIST_NAME_LOWER_SINGLE}. Please log out and log back in.`,
  CITATION_FROM_URL_ERROR: 'The website you are trying to cite is unreachable',
  EDIT_CITATION_ERROR: 'There was a problem with trying to edit your citation.',
  REQUIRED_URL_ERROR: 'For website citations, a URL is required',
  URL_NORESULTS_ERROR: 'This URL did not return any results',
  GET_FOOTNOTE_ERROR: 'There was a problem preparing your footnote',
  GET_PROJECTS_ERROR: `There was a problem loading your ${CITATION_LIST_NAME_LOWER_PLURAL}`,
  JWT_SET_USER_ERROR:
    'Something went wrong. Please try refreshing the application or trying again later.',
  // autocite request errors
  URL_EMPTY_ERROR: 'URL parameter cannot be empty.',
  CURL_ERROR: 'Curl error: Could not resolve',
  // EBR API
  HOME_API_ERROR: 'There was a problem loading the home page',
} as const
